export default "__VITE_ASSET__DzBcGPgd__"